export { AreaChartComponent } from './charts/area-chart.component'
export { BarChartComponent } from './charts/bar-chart.component'
export { ChartComponent } from './charts/chart.component'
export { LineChartComponent } from './charts/line-chart.component'
export { MapChartComponent } from './charts/map-chart.component'
export { MapComponent } from './charts/map.component'
export { PieChartComponent } from './charts/pie-chart.component'
export { ComboChartComponent } from './charts/combo-chart.component'

export { TableWidgetComponent } from './table-widget/table-widget.component'

export { KpiComponent } from './kpi/kpi.component'
export { WysiwygComponent } from './wysiwyg/wysiwyg.component'
export { ImageWidgetComponent } from './image-widget/image-widget.component'
export { DimensionValueComponent } from './dimension-value/dimension-value.component'

import { AreaChartComponent } from './charts/area-chart.component'
import { BarChartComponent } from './charts/bar-chart.component'
import { LineChartComponent } from './charts/line-chart.component'
import { PieChartComponent } from './charts/pie-chart.component'
import { ComboChartComponent } from './charts/combo-chart.component'
import { MapChartComponent } from './charts/map-chart.component'

import { TableWidgetComponent } from './table-widget/table-widget.component'

import { WysiwygComponent } from './wysiwyg/wysiwyg.component'
import { ImageWidgetComponent } from './image-widget/image-widget.component'
import { KpiComponent } from './kpi/kpi.component'
import { DimensionValueComponent } from './dimension-value/dimension-value.component'

export const WIDGETS_BY_NAME = {
  'area': AreaChartComponent,
  'bar': BarChartComponent,
  'line': LineChartComponent,
  'pie': PieChartComponent,
  'kpi': KpiComponent,
  'combo': ComboChartComponent,
  'map': MapChartComponent,
  'table': TableWidgetComponent,
  'wysiwyg': WysiwygComponent,
  'image': ImageWidgetComponent,
  'dimension-value': DimensionValueComponent
}
